import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;
  padding: 0 2rem;
`

export const Title = styled.h1`
  color: ${props => props.theme.colors.color122d52};
  font-family: 'Inter';
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.8rem;
`
